export default __webpack_public_path__ + "static/cruiselines-vv-activities-1-f129d3fda7895c86cd6152f583d56b5d.jpg";